import API from '../../../../../services/api';
import { headers } from '../helpers/functionalities.js';

export const API_FINANZAS = {
    getPagos: async () => {
        return await API.get('/finanzas/pagos').then(res => res.data);
    },
    getConciliacionesStatus: async () => {
        return await API.get('/finanzas/conciliaciones').then(res => res.data);
    },
    getComprobante: async (comprobante) => {
        return await API.get('/finanzas/comprobante/' + comprobante).then(res => res.data);
    },
    conciliarRF: async (data) => {
        return await API.post(`finanzas/conciliaciones/rf`, data, headers).then(res => res.data);
    },
    conciliarEbay: async (payoutId) => {
        return await API.post(`finanzas/conciliaciones/ebay/${payoutId}`).then(res => res.data);
    },
    conciliarOvoko: async (data) => {
        return await API.post(`finanzas/conciliaciones/ovoko`, data, headers).then(res => res.data);
    },
    conciliarOpisto: async (data) => {
        return await API.post(`finanzas/conciliaciones/opisto`, data, headers).then(res => res.data);
    },
    conciliarWallapop: async (data) => {
        return await API.post(`finanzas/conciliaciones/wallapop`, data, headers).then(res => res.data);
    },
    conciliarUsedWorldParts: async (data) => {
        return await API.post(`finanzas/conciliaciones/uwp`, data, headers).then(res => res.data);
    },
    conciliarBparts: async (data) => {
        return await API.post(`finanzas/conciliaciones/bparts`, data, headers).then(res => res.data);
    },
    conciliarNeryus: async (data) => {
        return await API.post(`finanzas/conciliaciones/neryus`, data, headers).then(res => res.data);
    },
}